export default {"src":"/_next/static/media/firebase.417d5eea.svg","height":2500,"width":1823,"blurWidth":0,"blurHeight":0};